import { render, staticRenderFns } from "./CopyShiftCrewAssignmentsDialog.vue?vue&type=template&id=7572a5f0&scoped=true&"
import script from "./CopyShiftCrewAssignmentsDialog.vue?vue&type=script&lang=ts&"
export * from "./CopyShiftCrewAssignmentsDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7572a5f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VList,VListItem,VListItemContent,VListItemSubtitle,VListItemTitle,VSpacer})
